<template>
    <div class="log-out" @click="logOut">
        <span class="material-symbols-outlined">
            logout
        </span>
        <div class="text">
            {{ $t('userComponent.logOut') }}
        </div>

    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import { navigationService } from '@/services/navigationService'

    export default defineComponent({
        methods: {
            logOut() {
                navigationService.goLogoutPage()
            }
        }
    })

</script>

<style lang="scss" scoped>
    .log-out {
        display: flex;
        align-items: center;
        cursor: pointer;
        margin-left: 20px;

        .text {
            margin-left: 5px;
        }
    }
</style>